import React from "react";

export function PriceColumnFormatter(
    row: any,
){
    return <span>{parseInt(row).toLocaleString()} ریال</span>
}